import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { useAppConfig } from "@ct-react/core";
import { SiteType } from "@shared/site-type";
import Wrapper from "../components/layout/wrapper";
import SeoHelmet from "../components/seo-helmet";
import "./common-cms.scss";

const transDefs = defineMessages({
  title: {
    id: "seo-title-about",
    defaultMessage: "Qualité garantie grâce à la coopérative C.I.T.I."
  },
  lead: {
    id: "seo-lead-about",
    defaultMessage: "La coopérative C.I.T.I regroupe plus de 50 membres à travers la Suisse. Ces derniers garantissent la qualité des logements en location ainsi que les services associés."
  },
  desc: {
    id: "about-desc",
    defaultMessage: "Créée en juin 2003, à l'initiative de professionnels de la branche, la C.I.T.I. est la Coopérative de l'innovation du Tourisme et de l'Immobilier. Ses membres sont des entreprises actives dans le milieu. La Coopérative répond à des besoins concrets du secteur du tourisme. Elle a pour but de mettre à disposition de ses membres des services informatiques spécifiques. Ces services comprennent la gestion des logements de vacances et la mise en réseau des agences au travers de rentalp.com, notre système de réservation directe."
  },
  descTwo: {
    id: "about-desc-two",
    defaultMessage: "Chaque année, plus de 100'000 clients font confiance aux membres de C.I.T.I pour leurs vacances. rentalp.com propose plus de 5'000 logements de vacances dans les Alpes. La plupart de logements sont classifiés selon la norme de Suisse Tourisme qui vous garantit une qualité irréprochable."
  },
  descThree: {
    id: "about-desc-three",
    defaultMessage: "Chacun de nos membres est bien sûr présent dans la station dans laquelle vous aurez choisi votre logement de vacances et se fera un plaisir de vous accueillir et vous choyer durant votre séjour. Il sera votre interlocuteur afin de satisfaire à toutes vos demandes. Chaque membre C.I.T.I vous garantit de belles vacances sans soucis."
  },
  descFour: {
    id: "about-desc-four",
    defaultMessage: "Merci de choisir C.I.T.I à travers notre plateforme rentalp.com."
  }
});

const seasonTransDefs = defineMessages({
  title: {
    id: "season-seo-title-about",
    defaultMessage: "Des locations saisonnières de qualité, garanties par la coopérative C.I.T.I."
  },
  lead: {
    id: "season-seo-lead-about",
    defaultMessage: "Notre coopérative regroupe plus de 50 professionnels du tourisme à travers toute la Suisse, tous engagés à proposer des logements soigneusement sélectionnés et des services fiables pour rendre votre séjour inoubliable." },
  desc: {
    id: "season-about-desc",
    defaultMessage: "Fondée en 2003 par des spécialistes du secteur, la Coopérative de l'Innovation du Tourisme et de l'Immobilier (C.I.T.I.) accompagne les agences locales et facilite la gestion de milliers de logements saisonniers. Grâce à notre plateforme seasonalp.com, nous connectons directement les vacanciers aux agences de chaque région, sans intermédiaire inutile." },
  descTwo: {
    id: "season-about-desc-two",
    defaultMessage: "Chaque année, plus de 100'000 voyageurs réservent leur séjour auprès des membres de C.I.T.I. Notre catalogue compte plus de 5'000 locations saisonnières dans les Alpes suisses, dont la majorité est classée selon les normes de qualité de Suisse Tourisme." },
  descThree: {
    id: "season-about-desc-three",
    defaultMessage: "En choisissant un logement proposé par un membre C.I.T.I., vous bénéficiez de l’accompagnement d’un professionnel présent sur place, qui connaît parfaitement la région et reste à votre écoute avant, pendant et après votre séjour. Notre mission : vous garantir un séjour serein, sans mauvaise surprise."},
  descFour: {
    id: "season-about-desc-four",
    defaultMessage: "Merci de faire confiance à C.I.T.I. et à notre plateforme seasonalp.com pour votre prochain séjour à la montagne."
  }
});

const AboutPage = () => {

  const intl = useIntl();
  const { options: { siteType } } = useAppConfig();

  if (siteType === SiteType.SEASONALP)
    return (
      <Wrapper.Centered as="main" className="rl-about cms-page">

        <SeoHelmet title={intl.formatMessage(seasonTransDefs.title)}
                   description={intl.formatMessage(seasonTransDefs.lead)}
                   canonical="/about" />

        <Wrapper.InnerTitle as="div" className="descripted-title">
          <h1>{intl.formatMessage(seasonTransDefs.title)}</h1>
          <div className="rl-lead">
            <p className="bolder">{intl.formatMessage(seasonTransDefs.lead)}</p>
            <p>{intl.formatMessage(seasonTransDefs.desc)}</p>
            <p>{intl.formatMessage(seasonTransDefs.descTwo)}</p>
            <p>{intl.formatMessage(seasonTransDefs.descThree)}</p>
            <p>{intl.formatMessage(seasonTransDefs.descFour)}</p>
          </div>
        </Wrapper.InnerTitle>

      </Wrapper.Centered>);

  return (
    <Wrapper.Centered as="main" className="rl-about cms-page">

      <SeoHelmet title={intl.formatMessage(transDefs.title)}
                 description={intl.formatMessage(transDefs.lead)}
                 canonical="/about" />

      <Wrapper.InnerTitle as="div" className="descripted-title">
        <h1>{intl.formatMessage(transDefs.title)}</h1>
        <div className="rl-lead">
          <p className="bolder">{intl.formatMessage(transDefs.lead)}</p>
          <p>{intl.formatMessage(transDefs.desc)}</p>
          <p>{intl.formatMessage(transDefs.descTwo)}</p>
          <p>{intl.formatMessage(transDefs.descThree)}</p>
          <p>{intl.formatMessage(transDefs.descFour)}</p>
        </div>
      </Wrapper.InnerTitle>

    </Wrapper.Centered>);

};

export default AboutPage;
